import { FC } from 'react';
import ArrowDown from 'images/arrow-down.svg';

const ArrowDownIcon: FC = () => {
  return <img src={ArrowDown} alt="arrow-down-icon" />;
};
export default ArrowDownIcon;
